import { render } from "./Orders.vue?vue&type=template&id=42377cf1"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
script.render = render

export default script